/**
 * Checks if link is viewed internally or externally.
 * Is not a part of state because if it changes the app must have reloaded fully.
 */

import axiosFetch from "./axiosFetch";
import jwt from "jsonwebtoken";
import { USER_TYPE } from "./constants";

const userType = () => {
  const { origin } = window.location;
  if (
    origin.toLowerCase().includes("dns")
  ) {
    return USER_TYPE.INTERNAL;
  } else {
    return USER_TYPE.EXTERNAL;
  }
};

const isExternalUser = () => {
  return userType() === USER_TYPE.EXTERNAL;
};

const isInternalUser = () => {
  return userType() === USER_TYPE.INTERNAL;
};

const isElanFsUser = () => {
  if (isExternalUser()) {
    return window.location.origin.includes("elanfs");
  } else {
    return false;
  }
};

// requests API for a token.
const getToken = async () => {
  const resp = await axiosFetch.post("cfp/token", {
    application_id: "ServiceRESTAppIDDEV",
  });
  return resp.data.token;
};

// sets the token to localStorage
const login = (token) => {
  window.localStorage.setItem("token", token);
};

// clears the token from localStorage
const logout = () => {
  window.localStorage.removeItem("token");
};

const getUserInfoData = async () => {
  const res = await axiosFetch.get("/auth/sso/userInfo");

  return res.data;
};

const getAdminUsers = async (partner) => {
  const { token } = window.localStorage;
  const res = await axiosFetch.get(`/${partner}/getAdminUsers`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

const isTokenExpired = () => {
  return false;

  const token = window.localStorage.getItem("token");
  if (token) {
    const decodedToken = jwt.decode(token, { complete: true });
    if (decodedToken?.payload?.exp) {
      const { payload } = decodedToken;
      return Date.now() > payload.exp * 1000;
    }
    return true;
  }
  return true;
};

// Helps prevent screen flash if token is not found.
const isTokenPresent = () => {
  return true;

  const token = window.localStorage.getItem("token");
  if (token) {
    return true;
  }
  return false;
};

const isActionAuthorized = (rolesNeeded, userRolesGranted) => {
  return rolesNeeded.every((role) => userRolesGranted.includes(role));
};

export {
  isActionAuthorized,
  userType,
  isExternalUser,
  isInternalUser,
  login,
  logout,
  getToken,
  getUserInfoData,
  getAdminUsers,
  isTokenExpired,
  isTokenPresent,
  isElanFsUser,
};
